<template>
  <div>
    <div class="event">
      <p>{{ $store.getters['getClientMeta'].name }}</p>
      <h3 class="line-title">Bahislerim</h3>

      <form v-on:submit.prevent="filterBtn" class="top-filter" v-if="_.isNull(activeCoupon)">
        <div class="buttons">
          <button type="button" @click="filter.status = null" class="button" :class="filter.status == null ? 'active' : ''">Hepsi</button>
          <button type="button" @click="filter.status = 2" class="button" :class="filter.status == 2 ? 'active' : ''">Kazanan</button>
          <button type="button" @click="filter.status = 3" class="button" :class="filter.status == 3 ? 'active' : ''">Kaybeden</button>
          <button type="button" @click="filter.status = 1" class="button" :class="filter.status == 1 ? 'active' : ''">Bekleyen</button>
        </div>
        <DatePicker 
        v-if="!isMobile" 
        format="dd.MM.yyyy" 
        placeholder="Başlangıç Tarihi"
        :full-month-name="true" 
        :monday-first="true" 
        :language="tr" 
        v-model="filter.start_date"/>

        <DatePicker 
        v-if="!isMobile" 
        placeholder="Bitiş Tarihi"
        format="dd.MM.yyyy" 
        :full-month-name="true" 
        :monday-first="true" 
        :language="tr" 
        v-model="filter.end_date"/>


        <input v-if="isMobile" v-model="filter.start_date" type="date" placeholder="Bitiş Tarihi">
        <input v-if="isMobile" v-model="filter.end_date" type="date" placeholder="Bitiş Tarihi">
        <ButtonLoader class="primary" :loader="btnLoading" :text="'Filtrele'" >
          <template name="icon">
            <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
          </template>
        </ButtonLoader>
      </form>
      <Loader v-if="loading"/>
      <div class="user-content-inc coupon-items" v-show="!loading">
          <div class="panel" v-if="_.isNull(activeCoupon)">
            <div class="title" v-if="!isMobile">Bahislerim</div>
            <div class="content">
                <div class="alert" v-show="_.isEmpty(data)">
                    Sonuç bulunamadı, Lütfen tarih veya arama seçeneklerini kontrol ediniz.
                </div>
                <div class="well-items" v-if="!_.isEmpty(data)">
                  <Coupon @click.native="open_coupon(item)" :status="item.status_name" :status_id="item.status" v-for="(item,key) in data" :key="key">
                      <template slot="title">#{{ item.coupon_id }} 
                         <slot v-if="item.coupon_type == 0">Tekli</slot>
                         <slot v-if="item.coupon_type == 1">Kombine</slot>
                         <slot v-if="item.coupon_type == 2">Sistem</slot>
                         Kupon</template>
                      <template slot="time">{{ $moment(item.created_at).format('DD/MM HH:mm:ss') }}</template>
                      <template slot="bet">{{ item.amount }} TRY</template>
                      <template slot="win">{{ item.estimated }} TRY</template>
                  </Coupon>
                </div>
                <div class="footer" v-show="!_.isEmpty(data)">
                  <paginate
                    :page-count="filter.pageTotal"
                    :page-range="6"
                    :force-page="filter.page"
                    :margin-pages="2"
                    :click-handler="fetchData"
                    :prev-text="'Geri'"
                    :next-text="'İleri'"
                    :container-class="'pagination'"
                    :page-class="'page-item'">
                  </paginate>
                </div>
            </div>
          </div>
          <div class="panel" v-if="!_.isNull(activeCoupon)">
                <div class="title" v-if="!isMobile"># {{ activeCoupon.coupon_id }} 
                  <slot v-if="activeCoupon.type == 0">Tekli</slot>
                  <slot v-if="activeCoupon.type == 1">Kombine</slot>
                  <slot v-if="activeCoupon.type == 2">{{ $t('coupon.system') }}</slot>
                </div>
                <div class="content coupon-content">
                    <Event :count="key + 1" :is_live="event.match_type_name" :status="event.outcome_name" :status_id="event.outcome" :event_id="event.coupon_detail_id" v-for="(event,key) in activeCoupon.detail" :key="key"> 
                      <template slot="home">{{ event.teams_name[0] }}</template>
                      <template slot="away">{{ event.teams_name[1] }}</template>
                      <template slot="time">{{ $moment(event.bet_time_detail.match_time).format('DD/MM HH:mm:ss') }}</template>
                      <template slot="market">  
                        {{ $getMarketName(event.market_translated, ((event.match_type) ? 'live' : 'pre'), event.sport_id, markets) }}
                      </template>
                      <template slot="outcome">
                        {{ getOddName(event.outcome_id) }}
                        {{ event.sbv != "#" ? '(' + event.sbv + ')' : '' }}
                      </template>
                      <template slot="odd">{{ event.parse_value }}</template>
                      <template slot="statistic">Skor: {{ event.bet_time_detail.match_scores }} </template>
                    </Event>
                </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import DatePicker from 'vuejs-datepicker';
  import {tr, en} from 'vuejs-datepicker/dist/locale'

  import Event from '../../components/User/Coupons/Event'
  import Coupon from '../../components/User/Coupons/Coupon'
  import DetailPanel from '../../components/User/Coupons/DetailPanel'
  import CouponInfo from '../../components/User/Coupons/CouponInfo'
  import FilterPanel from '../../components/Common/User/FilterPanel'
  import Header from '../../components/Common/User/Header'
  export default{
    data(){
      return{
        loading:false,
        activeCoupon:null,
        mobileFilter: false,
        filter:{
          pageTotal: 0,
          size: 10,
          page: 1,
          start_date: this.$moment().format('YYYY-MM-DD'),
          end_date: this.$moment().format('YYYY-MM-DD'),
          coupon_id: null,
          status:null,
        },
        data:[],
        tr: tr,
        en: en,
      }
    },
    created(){
      this.fetchData();
    },
    components:{
      DatePicker,
      Event,
      Coupon,
      Header,
      CouponInfo,
      DetailPanel,
      FilterPanel
    },
    watch:{
      mobileFilter(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      }
    },
    methods:{
      getOddName(prefix)
      {
        var odd  = _.find(this.odds, function(o) { return o.prefix == prefix})
        
        if(!_.isUndefined(odd) && !_.isEmpty(odd) && !_.isUndefined(odd.tr))
        {
          return odd.tr;
        }

        return prefix;
      },
      calcTotalOdd(detail)
      {
          var total = 1;
          _.forEach(detail, function(value) {
              total = parseFloat(total) * parseFloat(value.parse_value);
          });
          return total.toFixed(2);
      },
      filterBtn(){
        this.fetchData();
        this.mobileFilter = false;
      },
      filter_open(){
        this.mobileFilter = true;
      },
      open_coupon(val){
        this.activeCoupon = val
      },
      back(){
        this.activeCoupon = null;
      },
      fetchData(page = 1, size = null, silent = false)
      {
        this.filter.page = page;

        if (!_.isNull(size)) 
        {
            this.filter.size = size;
        }
        
        if(silent == false){
          this.loading = true;
        } 
        axios.get('/user/coupons', {params: this.filter }).then((response) => {
            this.data       					  = response.data.data.data;
            this.filter.pageTotal  = response.data.data.last_page;
        }).catch(() => {}).finally(() => {
            this.loading = false;
            this.btnLoading = false;
        });
        this.mobileFilter = false;
      },
    },
    computed:{
      markets()
      {
        return this.$store.getters['translate/markets'];
      },
      odds()
      {
        return this.$store.getters['translate/odds'];
      }
    }
  }
</script>